import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { of, throwError } from 'rxjs';
import { constants } from '../constants';
import { ENDPOINTS } from '~environments/environment';
import { ProfileBookingPayload } from '../models/action-payloads/profile-booking-payload';
import { GenericResponse } from '../shared/interfaces/generic-response.interface';

export const landingPages500 = () => {
  return [
    // 0
    {
      [ENDPOINTS.API_MICROSERVICE_BEGIN_DETAILS]: () => {
        return throwError(new HttpErrorResponse({status: constants.HTTP_STATUS_CODE.BACKEND_ERROR}));
      }
    }
  ];
};

export const LandingPages200 = () => {
  const result = [
    // 0
    {
      [ENDPOINTS.API_MICROSERVICE_BEGIN_DETAILS]: () => {
        return of(
          new HttpResponse({ body: { statusCode: 344, status: constants.HTTP_STATUS_CODE.BACKEND_ERROR } })
        );
      }
    }
  ];

  return result;
};

export const profileBookings: GenericResponse<ProfileBookingPayload> = {
  status: 200,
  errors: [],
  payload: {
    vdsId: 'fbbe99f4-6904-40af-ad86-6345da4c17f2',
    profileBookings: [
      {
        balanceDue: false,
        bookingChannel: 'ES',
        bookingCurrency: 'USD',
        bookingId: '1680230',
        bookingLinkReferences: [],
        bookingStatus: 'BK',
        bookingType: 'I',
        brand: 'R',
        consumerId: '0',
        deckNumber: '10',
        grantorPassengerId: '375394703',
        lastName: 'PATRICK',
        linkFlow: 'manual',
        linkType: 'SELF_ENHANCED',
        masterBookingId: '1680230',
        masterPassengerId: '375394703',
        musterStation: 'A2',
        numberOfNights: 7,
        officeCode: 'MIA',
        packageCode: 'ALTSTIP2',
        passengerId: '375394703',
        passengers: [
          {
            birthdate: '19971204',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'JAYLAN',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394703',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
          {
            birthdate: '20061209',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'LOUIS',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394711',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
        ],
        passengersInStateroom: [
          {
            birthdate: '19971204',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'JAYLAN',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394703',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
          {
            birthdate: '20061209',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'LOUIS',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394711',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
        ],
        preferred: false,
        sailDate: '20230628',
        shipCode: 'AL',
        stateroomDescription: '',
        stateroomNumber: '10128',
        stateroomSubtype: 'N',
        stateroomType: 'O',
        isBoardingExpressEnabled: false,
        isInternationalBooking: false,
      },
    ],
  },
};

export const beginDetailsResponse = {
  status: 200,
  errors: [],
  payload: {
    bookings: [
      {
        bookingId: 54372,
        countryCode: 'USA',
        agencyId: '0',
        bookingLockStatus: '',
        guests: [
          {
            isExpenseComplete: true,
            isReservationContractComplete: true,
            isAppointmentComplete: true,
            isPhotoComplete: true,
            isBoardingPassComplete: true,
            isPersonalDetailComplete: true,
            isContactInfoComplete: true,
            isEmergencyContactComplete: true,
            isTravelDocumentsComplete: true,
            isAddressComplete: true,
            guestId: 180235968,
            firstName: 'YENNY',
            middleName: '',
            lastName: 'SCHER',
            suffix: '',
            onlineCheckinStatus: 'COMPLETED',
            selectedLanguages: 'ENG',
            personalInfo: {
              birthdate: '19850715',
              gender: 'F'
            },
            travelPhoto: {
              photoId: '2348976',
              photoUri: '/AN/2019-07-04/20190422075222379.jpg'
            },
            contactInfo: {
              phoneNumber: {
                countryCode: 'USA',
                number: '7869541230'
              },
              email: 'test@test.com'
            },
            emergencyContactInfo: {
              name: 'TETRI',
              phoneNumber: '7869541230'
            },
            immigrationInfo: {
              countryOfBirth: 'USA',
              countryOfCitizenship: 'USA',
              countryOfResidence: 'USA',
              machineReadableTravelDocument: {
                firstName: 'YENNY',
                lastName: 'SCHER',
                documentNumber: 'PO0900990'
              },
              documentType: 'L',
              documents: [
                {
                  type: 'L',
                  number: 'PO0900990',
                  expiryDate: '20220101',
                  issuingState: 'MI',
                  firstName: 'YENNY',
                  lastName: 'SCHER',
                  birthdate: '19850715'
                }
              ]
            },
            cruiseSurvey: {
              cruiseCountWithUs: '0',
              cruiseCount: '0'
            },
            guestAddresses: [
              {
                addressType: 'PRE_ADDRESS'
              },
              {
                addressType: 'POST_ADDRESS'
              },
              {
                addressType: 'RESIDENTIAL_ADDRESS',
                address: '14450 SW 120TH ST',
                addressLine1: '14450 SW 120TH ST',
                city: 'MIAMI',
                stateCode: 'FL',
                postalCode: '33196',
                countryCode: 'USA'
              }
            ],
            validTravelDocuments: [
              {
                type: 'P',
                name: 'Passport'
              },
              {
                type: 'I',
                name: 'Passport Card'
              },
              {
                type: 'L',
                name: 'Enhanced Driver License'
              },
              {
                type: 'BD',
                name: 'Birth Certificate+Driver License'
              },
              {
                type: 'BM',
                name: 'Birth Certificate+Military ID Card'
              },
              {
                type: 'BT',
                name: 'Birth Certificate+State ID Card'
              },
              {
                type: 'BS',
                name: 'Birth Certificate+Student ID Card'
              },
              {
                type: 'RD',
                name: 'Birth Abroad Certificate+Driver License'
              },
              {
                type: 'RM',
                name: 'Birth Abroad Certificate+Military ID Card'
              },
              {
                type: 'RT',
                name: 'Birth Abroad Certificate+State ID Card'
              },
              {
                type: 'RS',
                name: 'Birth Abroad Certificate+Student ID Card'
              },
              {
                type: 'C',
                name: 'Naturalization Certificate'
              },
              {
                type: 'X',
                name: 'Nexus Card'
              },
              {
                type: 'E',
                name: 'Sentri Card'
              },
              {
                type: 'Z',
                name: 'Fast Card'
              }
            ]
          },
          {
            isExpenseComplete: true,
            isReservationContractComplete: true,
            isAppointmentComplete: true,
            isPhotoComplete: true,
            isBoardingPassComplete: true,
            isPersonalDetailComplete: true,
            isContactInfoComplete: true,
            isEmergencyContactComplete: true,
            isTravelDocumentsComplete: true,
            isAddressComplete: true,
            guestId: 180235950,
            firstName: 'ROBIN',
            middleName: '',
            lastName: 'SCHER',
            suffix: '',
            onlineCheckinStatus: 'COMPLETED',
            selectedLanguages: 'ENG',
            personalInfo: {
              birthdate: '19800428',
              gender: 'M'
            },
            travelPhoto: {
              photoId: '2348975',
              photoUri: '/AN/2019-07-04/20190506080455724.jpg'
            },
            contactInfo: {
              phoneNumber: {
                countryCode: 'USA',
                number: '7869541230'
              },
              email: 'test@test.com'
            },
            emergencyContactInfo: {
              name: 'TETRIS',
              phoneNumber: '7896954658'
            },
            immigrationInfo: {
              countryOfBirth: 'USA',
              countryOfCitizenship: 'USA',
              countryOfResidence: 'USA',
              machineReadableTravelDocument: {
                firstName: 'ROBIN',
                lastName: 'SCHER',
                documentNumber: 'PO09009'
              },
              documentType: 'P',
              documents: [
                {
                  type: 'P',
                  number: 'PO09009',
                  expiryDate: '20230101',
                  firstName: 'ROBIN',
                  lastName: 'SCHER',
                  birthdate: '19800428'
                }
              ]
            },
            cruiseSurvey: {
              cruiseCountWithUs: '0',
              cruiseCount: '0'
            },
            guestAddresses: [
              {
                addressType: 'PRE_ADDRESS'
              },
              {
                addressType: 'POST_ADDRESS'
              },
              {
                addressType: 'RESIDENTIAL_ADDRESS',
                address: '14450 SW 120TH ST',
                addressLine1: '14450 SW 120TH ST',
                city: 'MIAMI',
                stateCode: 'FL',
                postalCode: '33196',
                countryCode: 'USA'
              }
            ],
            validTravelDocuments: [
              {
                type: 'P',
                name: 'Passport'
              },
              {
                type: 'I',
                name: 'Passport Card'
              },
              {
                type: 'L',
                name: 'Enhanced Driver License'
              },
              {
                type: 'BD',
                name: 'Birth Certificate+Driver License'
              },
              {
                type: 'BM',
                name: 'Birth Certificate+Military ID Card'
              },
              {
                type: 'BT',
                name: 'Birth Certificate+State ID Card'
              },
              {
                type: 'BS',
                name: 'Birth Certificate+Student ID Card'
              },
              {
                type: 'RD',
                name: 'Birth Abroad Certificate+Driver License'
              },
              {
                type: 'RM',
                name: 'Birth Abroad Certificate+Military ID Card'
              },
              {
                type: 'RT',
                name: 'Birth Abroad Certificate+State ID Card'
              },
              {
                type: 'RS',
                name: 'Birth Abroad Certificate+Student ID Card'
              },
              {
                type: 'C',
                name: 'Naturalization Certificate'
              },
              {
                type: 'X',
                name: 'Nexus Card'
              },
              {
                type: 'E',
                name: 'Sentri Card'
              },
              {
                type: 'Z',
                name: 'Fast Card'
              }
            ]
          }
        ],
        associatedBookings: [],
        packageId: null,
        isLocked: false,
        guestDocumentStatus: false,
        isInternationalBooking: false,
        bookingOfficeCode: 'MIA'
      },
      {
        bookingId: 54406,
        countryCode: 'USA',
        agencyId: '0',
        bookingLockStatus: '',
        guests: [
          {
            isExpenseComplete: true,
            isReservationContractComplete: true,
            isAppointmentComplete: true,
            isPhotoComplete: false,
            isBoardingPassComplete: true,
            isPersonalDetailComplete: true,
            isContactInfoComplete: true,
            isEmergencyContactComplete: true,
            isTravelDocumentsComplete: true,
            isAddressComplete: true,
            guestId: 180236420,
            firstName: 'LAKSHA',
            middleName: '',
            lastName: 'MANANSALA',
            suffix: '',
            onlineCheckinStatus: 'REPRINT',
            selectedLanguages: 'ENG',
            personalInfo: {
              birthdate: '20110715',
              gender: 'F'
            },
            travelPhoto: {},
            contactInfo: {
              phoneNumber: {
                countryCode: 'USA',
                number: '8798565666'
              },
              email: 'test@test.com'
            },
            emergencyContactInfo: {
              name: 'TEST',
              phoneNumber: '5645455785'
            },
            immigrationInfo: {
              countryOfBirth: 'USA',
              countryOfCitizenship: 'USA',
              countryOfResidence: 'USA',
              machineReadableTravelDocument: {
                firstName: 'LAKSHA',
                lastName: 'MANANSALA',
                documentNumber: 'O98998'
              },
              documentType: 'X',
              documents: [
                {
                  type: 'X',
                  number: 'O98998',
                  expiryDate: '20220101',
                  firstName: 'LAKSHA',
                  lastName: 'MANANSALA',
                  birthdate: '20110715'
                }
              ]
            },
            cruiseSurvey: {
              cruiseCountWithUs: '0',
              cruiseCount: '0'
            },
            guestAddresses: [
              {
                addressType: 'PRE_ADDRESS'
              },
              {
                addressType: 'POST_ADDRESS'
              },
              {
                addressType: 'RESIDENTIAL_ADDRESS',
                address: '14450 SW 120TH ST',
                addressLine1: '14450 SW 120TH ST',
                city: 'MIAMI',
                stateCode: 'FL',
                postalCode: '33196',
                countryCode: 'USA'
              }
            ],
            validTravelDocuments: [
              {
                type: 'P',
                name: 'Passport'
              },
              {
                type: 'I',
                name: 'Passport Card'
              },
              {
                type: 'L',
                name: 'Enhanced Driver License'
              },
              {
                type: 'BN',
                name: 'Birth Certificate+No photo document required'
              },
              {
                type: 'RN',
                name: 'Birth Abroad Certificate+No photo document required'
              },
              {
                type: 'C',
                name: 'Naturalization Certificate'
              },
              {
                type: 'X',
                name: 'Nexus Card'
              },
              {
                type: 'E',
                name: 'Sentri Card'
              },
              {
                type: 'Z',
                name: 'Fast Card'
              }
            ]
          },
          {
            isExpenseComplete: true,
            isReservationContractComplete: true,
            isAppointmentComplete: true,
            isPhotoComplete: true,
            isBoardingPassComplete: true,
            isPersonalDetailComplete: true,
            isContactInfoComplete: true,
            isEmergencyContactComplete: true,
            isTravelDocumentsComplete: true,
            isAddressComplete: true,
            guestId: 180236412,
            firstName: 'ROGER',
            middleName: '',
            lastName: 'MANANSALA',
            suffix: '',
            onlineCheckinStatus: 'REPRINT',
            selectedLanguages: 'ENG',
            personalInfo: {
              birthdate: '19800428',
              gender: 'M',
            },
            travelPhoto: {
              photoId: '2349274',
              photoUri: '/AN/2019-07-04/20190506145856115.jpg'
            },
            contactInfo: {
              phoneNumber: {
                countryCode: 'USA',
                number: '7895565656'
              },
              email: 'test@test.com'
            },
            emergencyContactInfo: {
              name: 'TEST',
              phoneNumber: '7869541235'
            },
            immigrationInfo: {
              countryOfBirth: 'USA',
              countryOfCitizenship: 'USA',
              countryOfResidence: 'USA',
              machineReadableTravelDocument: {
                firstName: 'ROGER',
                lastName: 'MANANSALA',
                documentNumber: '099888'
              },
              documentType: 'I',
              documents: [
                {
                  type: 'I',
                  number: '099888',
                  expiryDate: '20220101',
                  firstName: 'ROGER',
                  lastName: 'MANANSALA',
                  birthdate: '19800428'
                }
              ]
            },
            cruiseSurvey: {
              cruiseCountWithUs: '0',
              cruiseCount: '0'
            },
            guestAddresses: [
              {
                addressType: 'PRE_ADDRESS'
              },
              {
                addressType: 'POST_ADDRESS'
              },
              {
                addressType: 'RESIDENTIAL_ADDRESS',
                address: '14450 SW 120TH ST',
                addressLine1: '14450 SW 120TH ST',
                city: 'MIAMI',
                stateCode: 'FL',
                postalCode: '33196',
                countryCode: 'USA'
              }
            ],
            validTravelDocuments: [
              {
                type: 'P',
                name: 'Passport'
              },
              {
                type: 'I',
                name: 'Passport Card'
              },
              {
                type: 'L',
                name: 'Enhanced Driver License'
              },
              {
                type: 'BD',
                name: 'Birth Certificate+Driver License'
              },
              {
                type: 'BM',
                name: 'Birth Certificate+Military ID Card'
              },
              {
                type: 'BT',
                name: 'Birth Certificate+State ID Card'
              },
              {
                type: 'BS',
                name: 'Birth Certificate+Student ID Card'
              },
              {
                type: 'RD',
                name: 'Birth Abroad Certificate+Driver License'
              },
              {
                type: 'RM',
                name: 'Birth Abroad Certificate+Military ID Card'
              },
              {
                type: 'RT',
                name: 'Birth Abroad Certificate+State ID Card'
              },
              {
                type: 'RS',
                name: 'Birth Abroad Certificate+Student ID Card'
              },
              {
                type: 'C',
                name: 'Naturalization Certificate'
              },
              {
                type: 'X',
                name: 'Nexus Card'
              },
              {
                type: 'E',
                name: 'Sentri Card'
              },
              {
                type: 'Z',
                name: 'Fast Card'
              }
            ]
          }
        ],
        associatedBookings: [],
        packageId: null,
        isLocked: false,
        guestDocumentStatus: false,
        isInternationalBooking: false,
        bookingOfficeCode: 'MIA'
      },
      {
        bookingId: 54407,
        countryCode: 'USA',
        agencyId: '0',
        bookingLockStatus: '',
        guests: [
          {
            isExpenseComplete: false,
            isReservationContractComplete: false,
            isAppointmentComplete: false,
            isPhotoComplete: false,
            isBoardingPassComplete: false,
            isPersonalDetailComplete: true,
            isContactInfoComplete: true,
            isEmergencyContactComplete: true,
            isTravelDocumentsComplete: true,
            isAddressComplete: true,
            guestId: 180236446,
            firstName: 'KATYA',
            middleName: '',
            lastName: 'KOSTELECKY',
            suffix: '',
            onlineCheckinStatus: 'IN_PROGRESS',
            selectedLanguages: 'eng',
            personalInfo: {
              birthdate: '19850715',
              gender: 'F'
            },
            travelPhoto: {},
            contactInfo: {
              phoneNumber: {
                countryCode: 'USA',
                number: '7869541230'
              },
              email: 'test@test.com'
            },
            emergencyContactInfo: {
              name: 'TEST',
              phoneNumber: '7869541238'
            },
            immigrationInfo: {
              countryOfBirth: 'USA',
              countryOfCitizenship: 'USA',
              countryOfResidence: 'USA',
              machineReadableTravelDocument: {
                firstName: 'KATYA',
                lastName: 'KOSTELECKY',
                documentNumber: '98788787'
              },
              documentType: 'Z',
              documents: [
                {
                  type: 'Z',
                  number: '98788787',
                  expiryDate: '20330201',
                  firstName: 'KATYA',
                  lastName: 'KOSTELECKY',
                  birthdate: '19850715'
                }
              ]
            },
            cruiseSurvey: {
              cruiseCountWithUs: '0',
              cruiseCount: '0'
            },
            guestAddresses: [
              {
                addressType: 'PRE_ADDRESS'
              },
              {
                addressType: 'POST_ADDRESS'
              },
              {
                addressType: 'RESIDENTIAL_ADDRESS',
                address: '14450 SW 120TH ST',
                addressLine1: '14450 SW 120TH ST',
                city: 'MIAMI',
                stateCode: 'FL',
                postalCode: '33196',
                countryCode: 'USA'
              }
            ],
            validTravelDocuments: [
              {
                type: 'P',
                name: 'Passport'
              },
              {
                type: 'I',
                name: 'Passport Card'
              },
              {
                type: 'L',
                name: 'Enhanced Driver License'
              },
              {
                type: 'BD',
                name: 'Birth Certificate+Driver License'
              },
              {
                type: 'BM',
                name: 'Birth Certificate+Military ID Card'
              },
              {
                type: 'BT',
                name: 'Birth Certificate+State ID Card'
              },
              {
                type: 'BS',
                name: 'Birth Certificate+Student ID Card'
              },
              {
                type: 'RD',
                name: 'Birth Abroad Certificate+Driver License'
              },
              {
                type: 'RM',
                name: 'Birth Abroad Certificate+Military ID Card'
              },
              {
                type: 'RT',
                name: 'Birth Abroad Certificate+State ID Card'
              },
              {
                type: 'RS',
                name: 'Birth Abroad Certificate+Student ID Card'
              },
              {
                type: 'C',
                name: 'Naturalization Certificate'
              },
              {
                type: 'X',
                name: 'Nexus Card'
              },
              {
                type: 'E',
                name: 'Sentri Card'
              },
              {
                type: 'Z',
                name: 'Fast Card'
              }
            ]
          },
          {
            isExpenseComplete: true,
            isReservationContractComplete: false,
            isAppointmentComplete: false,
            isPhotoComplete: false,
            isBoardingPassComplete: true,
            isPersonalDetailComplete: true,
            isContactInfoComplete: true,
            isEmergencyContactComplete: true,
            isTravelDocumentsComplete: true,
            isAddressComplete: true,
            guestId: 180236438,
            firstName: 'ERIC',
            middleName: '',
            lastName: 'KOSTELECKY',
            suffix: '',
            onlineCheckinStatus: 'COMPLETED',
            selectedLanguages: 'ENG',
            personalInfo: {
              birthdate: '19800428',
              gender: 'M'
            },
            travelPhoto: {},
            contactInfo: {
              phoneNumber: {
                countryCode: 'USA',
                number: '7869541230'
              },
              email: 'test@test.com'
            },
            emergencyContactInfo: {
              name: 'TEST',
              phoneNumber: '7869541230'
            },
            immigrationInfo: {
              countryOfBirth: 'USA',
              countryOfCitizenship: 'USA',
              countryOfResidence: 'USA',
              machineReadableTravelDocument: {
                firstName: 'ERIC',
                lastName: 'KOSTELECKY'
              },
              documentType: 'RD',
              documents: [
                {
                  type: 'R',
                  issuingState: 'AZ',
                  firstName: 'ERIC',
                  lastName: 'KOSTELECKY',
                  birthdate: '19800428'
                },
                {
                  type: 'D',
                  issuingState: 'AK',
                  firstName: 'ERIC',
                  lastName: 'KOSTELECKY',
                  birthdate: '19800428'
                }
              ]
            },
            cruiseSurvey: {
              cruiseCountWithUs: '0',
              cruiseCount: '0'
            },
            guestAddresses: [
              {
                addressType: 'PRE_ADDRESS'
              },
              {
                addressType: 'POST_ADDRESS'
              },
              {
                addressType: 'RESIDENTIAL_ADDRESS',
                address: '14450 SW 120TH ST',
                addressLine1: '14450 SW 120TH ST',
                city: 'MIAMI',
                stateCode: 'FL',
                postalCode: '33196',
                countryCode: 'USA'
              }
            ],
            validTravelDocuments: [
              {
                type: 'P',
                name: 'Passport'
              },
              {
                type: 'I',
                name: 'Passport Card'
              },
              {
                type: 'L',
                name: 'Enhanced Driver License'
              },
              {
                type: 'BD',
                name: 'Birth Certificate+Driver License'
              },
              {
                type: 'BM',
                name: 'Birth Certificate+Military ID Card'
              },
              {
                type: 'BT',
                name: 'Birth Certificate+State ID Card'
              },
              {
                type: 'BS',
                name: 'Birth Certificate+Student ID Card'
              },
              {
                type: 'RD',
                name: 'Birth Abroad Certificate+Driver License'
              },
              {
                type: 'RM',
                name: 'Birth Abroad Certificate+Military ID Card'
              },
              {
                type: 'RT',
                name: 'Birth Abroad Certificate+State ID Card'
              },
              {
                type: 'RS',
                name: 'Birth Abroad Certificate+Student ID Card'
              },
              {
                type: 'C',
                name: 'Naturalization Certificate'
              },
              {
                type: 'X',
                name: 'Nexus Card'
              },
              {
                type: 'E',
                name: 'Sentri Card'
              },
              {
                type: 'Z',
                name: 'Fast Card'
              }
            ]
          }
        ],
        associatedBookings: [],
        packageId: null,
        isLocked: false,
        guestDocumentStatus: false,
        isInternationalBooking: false,
        bookingOfficeCode: 'MIA'
      }
    ],
    warnings: [],
    checkinToken:
      'eyJhbGciOiJIUzUxMiJ9.eyJndWVzdEFjY291bnRJZCI6Ikc4MDYxNzUwIiwiaXBBZGRyZXNzIjoiMC4wLjAuMCIsImdyYW50b3IiOnsiYm9va2luZ0lkIjo1NDQwNiwiZ3Vlc3RJZCI6MTgwMjM2NDIwfSwic291cmNlIjoiV2ViIiwiZXhwIjoxNTU4NTMzNjMwLCJzYWlsRGF0ZSI6IjIwMTkwNzA0IiwiaWF0IjoxNTU4NTMwMDMwLCJncmFudGVlcyI6W3siYm9va2luZ0lkIjo1NDM3MiwiZ3Vlc3RJZCI6MTgwMjM1OTY4fSx7ImJvb2tpbmdJZCI6NTQzNzIsImd1ZXN0SWQiOjE4MDIzNTk1MH0seyJib29raW5nSWQiOjU0NDA2LCJndWVzdElkIjoxODAyMzY0MjB9LHsiYm9va2luZ0lkIjo1NDQwNiwiZ3Vlc3RJZCI6MTgwMjM2NDEyfSx7ImJvb2tpbmdJZCI6NTQ0MDcsImd1ZXN0SWQiOjE4MDIzNjQ0Nn0seyJib29raW5nSWQiOjU0NDA3LCJndWVzdElkIjoxODAyMzY0Mzh9XSwic2hpcENvZGUiOiJBTiJ9.A8j15HbCt1omvk2pOwBI6KB04D5wsWitqHow85qOkNlhm3jv2zD_T2Z60QiGziU99uEvhSZbkwLENPBLv-kETw'
  }
};

export const profileBookingsIntAndDomestic: GenericResponse<ProfileBookingPayload>  = {
  status: 200,
  errors: [],
  payload: {
    vdsId: 'fbbe99f4-6904-40af-ad86-6345da4c17f2',
    profileBookings: [
      {
        balanceDue: false,
        bookingChannel: 'ES',
        bookingCurrency: 'GBP',
        bookingId: '1680230',
        bookingLinkReferences: [],
        bookingStatus: 'BK',
        bookingType: 'I',
        brand: 'R',
        consumerId: '0',
        deckNumber: '10',
        grantorPassengerId: '375394703',
        lastName: 'PATRICK',
        linkFlow: 'manual',
        linkType: 'SELF_ENHANCED',
        masterBookingId: '1680230',
        masterPassengerId: '375394703',
        musterStation: 'A2',
        numberOfNights: 7,
        officeCode: 'LON',
        packageCode: 'ALTSTIP2',
        passengerId: '375394703',
        passengers: [
          {
            birthdate: '19971204',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'JAYLAN',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394703',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
          {
            birthdate: '20061209',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'LOUIS',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394711',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
        ],
        passengersInStateroom: [
          {
            birthdate: '19971204',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'JAYLAN',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394703',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
          {
            birthdate: '20061209',
            consumerId: '0',
            email: 'DUMMY@CASSANDRA.COM',
            endBoardingTime: '153000UTC',
            firstName: 'LOUIS',
            lastName: 'PATRICK',
            onlineCheckinStatus: 'NOT_STARTED',
            passengerId: '375394711',
            passengerStatus: 'AC',
            startBoardingTime: '130000UTC',
            stateroomNumber: '10128',
            stateroomType: 'O',
            title: '',
          },
        ],
        preferred: false,
        sailDate: '20230628',
        shipCode: 'AL',
        stateroomDescription: '',
        stateroomNumber: '10128',
        stateroomSubtype: 'N',
        stateroomType: 'O',
        isBoardingExpressEnabled: false,
        isInternationalBooking: true,
      },
    ],
  },
};
